import { formatDateTime } from "../../utils/formatDate";

export type CompValidationAuditRow = {
  manually_validated?: boolean;
  manually_validated_by_user_id?: number | null;
  manually_validated_at?: string | null;
};

export function compValidationTooltipTitle(
  row: CompValidationAuditRow | null | undefined,
  resolveUserName?: (userId: number) => string | null,
): string | null {
  if (!row || row.manually_validated !== true) return null;

  const userId = row.manually_validated_by_user_id;
  const userName =
    typeof userId === "number"
      ? resolveUserName?.(userId)?.trim() || `User ${userId}`
      : null;
  const when = row.manually_validated_at
    ? formatDateTime(row.manually_validated_at)
    : null;

  if (userName && when && when !== "-") {
    return `Validated by ${userName} on ${when}`;
  }
  if (userName) return `Validated by ${userName}`;
  if (when && when !== "-") return `Validated on ${when}`;
  return "Validated";
}
